import React from 'react';
import { RouteObject } from 'react-router-dom';
import BillsLanding from './components/Landing';
import { PayBill } from './components/pay-bill/PayBill';

export interface billsRoute extends Omit<RouteObject, 'children'> {
  auth?: boolean;
  children?: billsRoute[];
}

export const billsRoutes: billsRoute[] = [
  {
    path: '/dashboard/billing',
    element: <BillsLanding />,
    auth: false,
  },
  {
    path: '/dashboard/billing/pay',
    element: <PayBill />,
    auth: false,
  },
];
